"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.MarkAndLabel = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var RC = _interopRequireWildcard(require("./RadioCheckboxParts"));
var _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Label = (0, _styledComponents["default"])(RC.Label).withConfig({
  displayName: "RadioButtonPillParts__Label",
  componentId: "sc-1enxj3r-0"
})(["width:100%;height:auto;padding:", " ", ";color:", ";border:1px solid currentColor;background-color:transparent;border-radius:15px;text-align:center;font-size:", ";line-height:", ";"], function (props) {
  return props.theme.spaces.xxs;
}, function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return (0, _helpers.getColor)(props, "color", "focus");
}, function (props) {
  return props.theme.fields.fontSize;
}, function (props) {
  return props.theme.fields.radioIconSize;
});
var Wrapper = (0, _styledComponents["default"])(RC.Wrapper).withConfig({
  displayName: "RadioButtonPillParts__Wrapper",
  componentId: "sc-1enxj3r-1"
})(["input:checked ~ ", "{background-color:", ";color:", ";}"], Label, function (props) {
  return (0, _helpers.getColor)(props, "color", "focus");
}, function (props) {
  return (0, _helpers.getColor)(props, "hoverColor", "textInverted");
});
exports.Wrapper = Wrapper;
var MarkAndLabel = function MarkAndLabel(_ref) {
  var htmlFor = _ref.htmlFor,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: htmlFor
  }, children);
};
exports.MarkAndLabel = MarkAndLabel;
MarkAndLabel.propTypes = {
  htmlFor: _propTypes["default"].string,
  children: _propTypes["default"].node
};